import $ from "jquery";
import register from "flow/knockout/register";

register.registerKnockoutBinding("linkListPopover", {
    init: function () {
        $("body").on("click", function (e) {
            const target = $(e.target);
            if (!target.parents(".lc-link-button-area").length) {
                if (!target.parents(".lc-link-list-popover").length) {
                    $(".lc-link-list-popover").hide();
                }
            }
        });
    },
    update: function () {
        const roundLinkButton = $(".lc-link-button-area span").first();
        if (roundLinkButton.length) {
            const popOver = $(".lc-link-list-popover");

            // Move popover under links button
            const popOverTop = roundLinkButton.position().top + roundLinkButton.height() + 4;
            const popOverLeft = roundLinkButton.position().left;
            popOver.css({ left: popOverLeft, top: popOverTop });
        }
    }
});
